
/* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
var tabsSliderDropdown = document.getElementById("tabsSliderDropdown")

var clickHandler1 = function () {
    tabsSliderDropdown.classList.toggle("showSection")
    const link1 = document.getElementById("dropdownNav")
    link1.classList.toggle("show")
}

if (tabsSliderDropdown)
  tabsSliderDropdown.addEventListener('click', clickHandler1)

